
import React, { Component} from 'react';
//Functional Component 

import axios from 'axios';

function postDbData(name, paypal)
{
  const url = "https://auxilliabackend.herokuapp.com/adddata"
  console.log("here")
  axios.post(url,{
    name: name,
    email: localStorage.getItem('email'),
    paypal: paypal
  })
  .then(function (response) {
    //window.location.reload(true);
    console.log(response);
  })
  .catch(function (error) {
    console.log(error);
  });
}

//class studentProfileSetupPage extends React.Component
class studentProfileSetupPage extends React.Component{
    constructor(props) {
      
        super(props);
        this.state = { 
         
          name: "",
          //email: "",
          paypal: ""
         };
        this.submitter = this.submitter.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        
      }
      
      handleInputChange = (event) => {
        console.log("Changing", event.target.name);
        this.setState({
          [event.target.name]: event.target.value
        })
      }
    
    
      submitter(e){
        console.log("submitting function");
        e.preventDefault();
        postDbData(this.state.name,this.state.paypal);
        //postDbData(this.state.name,this.state.email,this.state.paypal);
        console.log("Submit log in information");
        this.props.history.push({pathname: '/home'});
      }
    
      render() {
        return (
          <div className="App">
            
        
            <body className = "App-header">
              <div class = "submitbox">
                <img src = "logo192.png" class = "logo"></img>
                <h1>Set Up</h1>
                  <form id="loginForm" onSubmit = {this.submitter}>
                    {/* <p>Username</p> */}
                    <input type = "text" name = "name" placeholder = "Enter Username" onChange = {this.handleInputChange}></input>
                    {/* <input type = "text" name="" placeholder = "Enter Email" onChange = {this.handleInputChange}></input> */}
                    <input type = "text" name = "paypal" placeholder = "Enter Paypal Email" onChange = {this.handleInputChange}></input>

                    <input type = "submit" name = "submit" value = "Submit" onChange = {this.handleInputChange}></input >
                  </form>

              </div>
            </body>
            </div>
          // <div>   
          //   <form id="loginForm" onSubmit={this.submitter} >
          //       <label style={{display:'block',padding:'2%'}}>
          //       Name:
          //       <input type="text" name="name" style={{width:'50%'}} onChange={this.handleInputChange} />
          //       </label>
                
          //       <label style={{display:'block',padding:'2%'}}>
          //       Email:
          //       <input type="text" name="email" style={{width:'50%'}} onChange={this.handleInputChange}/>
          //       </label>
          //       <label style={{display:'block',padding:'2%'}}>
          //       PayPal Email:   
          //       <input type="text" name="paypal" style={{width:'50%'}} onChange={this.handleInputChange}/>
          //       </label>
          //       <input type="submit" value="Submit" style={{display:'block',padding:'2%'}}/>
          //   </form>
        
          // </div>
        );
      }
  }




export default studentProfileSetupPage;